import React from 'react';
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Divider,
  alpha,
  useTheme,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useTranslation } from 'react-i18next';
import SEO from '../../components/SEO';
import PageShell, { SurfaceCard } from '../../components/common/PageShell';

const FAQ = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const sections = [
    {
      title: t('faq.general.title'),
      questions: Object.values(t('faq.general.questions', { returnObjects: true })),
    },
    {
      title: t('faq.security.title'),
      questions: Object.values(t('faq.security.questions', { returnObjects: true })),
    },
    {
      title: t('faq.payment.title'),
      questions: Object.values(t('faq.payment.questions', { returnObjects: true })),
    },
    {
      title: t('faq.account.title'),
      questions: Object.values(t('faq.account.questions', { returnObjects: true })),
    },
  ];

  return (
    <>
      <SEO title={t('faq.title')} description={t('faq.description')} />
      <PageShell
        maxWidth="md"
        title={t('faq.title')}
        subtitle={t('faq.subtitle')}
        icon={<HelpOutlineIcon />}
      >
        {sections.map((section, index) => (
          <Box key={index} sx={{ mb: 3.5 }}>
            <Typography variant="h6" fontWeight={800} sx={{ mb: 1.5 }}>
              {section.title}
            </Typography>
            <SurfaceCard>
              {section.questions.map((item, qIndex) => (
                <Accordion
                  key={qIndex}
                  disableGutters
                  elevation={0}
                  sx={{
                    bgcolor: 'transparent',
                    '&:before': { display: 'none' },
                    borderBottom:
                      qIndex < section.questions.length - 1
                        ? `1px solid ${alpha(theme.palette.divider, 0.9)}`
                        : 'none',
                  }}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography fontWeight={600}>{item.question}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography color="text.secondary" sx={{ lineHeight: 1.7 }}>
                      {item.answer}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </SurfaceCard>
            {index < sections.length - 1 && <Divider sx={{ my: 3, opacity: 0 }} />}
          </Box>
        ))}
      </PageShell>
    </>
  );
};

export default FAQ;
